module.exports = __webpack_public_path__ + "static/logo-e480102d05d61fd2ab500dc717f4d792.png";